import script from "./AIAssistantTranscriptionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AIAssistantTranscriptionModal.vue?vue&type=script&setup=true&lang=ts"

import "./AIAssistantTranscriptionModal.vue?vue&type=style&index=0&id=faa84066&scoped=true&lang=scss"
import "./AIAssistantTranscriptionModal.vue?vue&type=style&index=1&id=faa84066&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-faa84066"]])

export default __exports__